angular.module('galilai.creator').factory('animator', function ($timeout, $rootScope, videoService) {

    const MAX_DURATION = 3 * 60 * 1000
    const WORDS_PER_MINUTE_READING = 320
    const MIN_PAGE_DURATION = 2500
    const TRANSITION_DURATION = 300
    const ADD_ENDING_DURATION_ENABLED = false
    const DEBUG_TIMELINE = false

    let requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

    return function() {
        let self = {}

        self.state = {
            started: false,
            items: [],
            wordPerMinute: WORDS_PER_MINUTE_READING,
            theme: {},
            startTimer: null,
            eventsStarted: false,
        }

        function easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }

        function tween(easingFunction, currentTime, startValue, targetValue, duration, delay) {
            const updateTime = (value, target) => {
                if (typeof value === 'object' && typeof target === 'object') {
                    const result = {};
                    for (const key in value) {
                        if (target.hasOwnProperty(key)) {
                            result[key] = updateTime(value[key], target[key]);
                        }
                    }
                    return result;
                } else {
                    return value + (target - value) * easingFunction((currentTime - delay) / duration);
                }
            };

            // Ensure that the time is within the duration and delay
            if (currentTime < delay) {
                return {
                    value: startValue,
                    type: '<',
                    active: false,
                }
            } else if (currentTime - delay > duration) {
                return {
                    type: '>',
                    value: targetValue,
                    active: false,
                    last: true,
                }
            } else {
                return {
                    type: '==',
                    value: updateTime(startValue, targetValue),
                    active: true,
                }
            }
        }

        function getElementVisualSettings(groupId, elementId) {
            if (!groupId) {
                return {}
            }
            // Get number only from groupId
            groupId = groupId.replace(/\D/g, '')
            if (!self.state.theme) {
                return {}
            }
            if (!self.state.theme.settings) {
                return {}
            }
            if (!self.state.theme.settings[groupId]) {
                return {}
            }
            if (!self.state.theme.settings[groupId].visual) {
                return {}
            }
            if (!self.state.theme.settings[groupId].visual.elements) {
                return {}
            }
            if (!self.state.theme.settings[groupId].visual.elements[elementId]) {
                return {}
            }
            return self.state.theme.settings[groupId].visual.elements[elementId]
        }

        function getLayers(layout, groupId) {
            let layers = []
            let ignoreTypes = [
                'clipPath',
                'svg', // TODO
            ]
            if (layout.elements) {
                layout.elements.forEach(function(element) {
                    if (element.originalId == 'background') {
                        return
                    }
                    if (element.id.indexOf('background') != -1) {
                        return
                    }
                    if (ignoreTypes.indexOf(element.type) != -1) {
                        return
                    }
                    if (element.area && element.area.indexOf('main') != -1) {
                        return
                    }
                    if (element.area && element.area.indexOf('page_bg') != -1) {
                        return
                    }
                    if (element.type != 'container' && typeof element.type != 'undefined') {
                        let value = element.value
                        if (element.type == 'overlay') {
                            value = ''
                        } else if (value && value.length > 30) {
                            value = value.substring(0, 30) + '...'
                        }
                        let style = {}
                        let visualSettings = getElementVisualSettings(groupId, element.id)
                        if (visualSettings.translate) {
                            style.x = visualSettings.translate.x
                            style.y = visualSettings.translate.y
                        }
                        if (visualSettings.scale) {
                            style.scale = visualSettings.scale
                        }
                        let layer = {
                            uniqueId: element.id,
                            element: element,
                        }
                        if (style) {
                            layer.style = style
                        }
                        layers.push(layer)
                    }
                    if (element.elements) {
                        layers = layers.concat(getLayers(element, groupId))
                    }
                })
            }
            return layers
        }

        self.shouldAutoStart = function() {
            let isRecording = false
            try {
                let renderKind = new URLSearchParams(window.location.search).get('renderKind')
                isRecording = renderKind == 'video'
            } catch (e) {
                console.error('=> Error getting recording', e)
            }
            return !isRecording
        }

        self.onDocumentMessage = function (event) {
            if (!self.isAnimatorEnabled()) {
                return
            }
            console.log('=> Message received', event.data)
            if (!self.state.started) {
                return
            }
            if (event.data.type == 'animation' && event.data.action == 'start') {
                document.querySelector('body').classList.add('animation-wrapper')
                self.start('manual')
            }
            if (event.data.type == 'animation' && event.data.action == 'play-once') {
                document.querySelector('body').classList.add('animation-wrapper')
                self.start('play-once')
            }
            if (event.data.type == 'animation' && event.data.action == 'play-loop') {
                document.querySelector('body').classList.add('animation-wrapper')
                self.start('loop')
            }
            if (event.data.type == 'animation' && event.data.action == 'get-duration') {
                document.querySelector('body').classList.add('animation-wrapper')
                self.getTimelineDuration(function(err, timeline) {
                    let duration = timeline? timeline.duration : 0
                    // TODO - hardcoded
                    duration = Math.min(duration, MAX_DURATION)

                    window.postMessage(
                        {
                            videos: timeline?.videos ? timeline.videos: [],
                            duration: duration,
                            coverTime: timeline? timeline.coverTime : 0,
                            kind: 'response',
                            name: 'onStep',
                            id: event.data.id
                        }, '*');
                })

            }
            if (event.data.type == 'animation' && event.data.action == 'continue') {
                self.step(event.data.time, function() {
                    console.log('=> Step finished', self.state.timeline)
                    window.postMessage(
                        {
                            duration: self.state.timeline.duration,
                            coverTime: self.state.timeline.coverTime,
                            kind: 'response',
                            name: 'onStep',
                            id: event.data.id
                        }, '*');
                })
            }
        }
        self.isRenderingImage = function() {
            let render = new URLSearchParams(window.location.search).get('renderKind')
            return render == 'image'
        }
        self.isAnimatorEnabled = function() {
            return !self.isRenderingImage()
        }
        self.init = function(items, theme, params) {
            if (!self.isAnimatorEnabled()) {
                return
            }
            let shouldAutoStart = self.shouldAutoStart()
            if (!self.state.started && !shouldAutoStart) {
                self.state.eventsStarted = true
                document.querySelector('body').classList.add('animation-wrapper')
                window.addEventListener('message', self.onDocumentMessage)
            }
            self.state.started = true
            self.state.items = items
            if (params && params.timeline && params.timeline.main && params.timeline.main.speed) {
                self.state.wordPerMinute = getValidNumber(params.timeline.main.speed, WORDS_PER_MINUTE_READING)
            }
            if (theme) {
                self.state.theme = JSON.parse(JSON.stringify(theme))
            }

            // TODO - this is wrong
            // Overlay posts
            if ($rootScope.isCalendar()) {
                return
            }
            let elements = document.querySelectorAll('galilai-canvas .parent-item')
            for (let i = 0; i < elements.length; i++) {
                elements[i].style.zIndex = elements.length - i
            }
        }

        /*
            global spec - modern, simple, business, etc
            local spec - specific to the item (image, text, etc)
            duration
        */

        function getDOMElement(groupId, uniqueId) {
            let groupQuery = '[container-id="' + groupId + '"]'
            let query = groupQuery + ' [data-id="' + uniqueId + '"]'
            let element = document.querySelector(query)
            return element
        }

        function getTransition(layer, {reverse, parentId, groupId, time}) {
            layer = JSON.parse(JSON.stringify(layer))

            let groupQuery = '[container-id="' + groupId + '"]'
            let query = groupQuery + ' [data-id="' + layer.uniqueId + '"]'
            let element = document.querySelector(query)

            let parent = element
            while (parent && parent.tagName != 'CONTAINER') {
                parent = parent.parentElement
            }
            if (!parent) {
                console.error('=> Parent not found', layer)
                return null
            }
            // TODO - BUgged need to wait
            let parentBB = parent.getBoundingClientRect()
            let elementBB = element.getBoundingClientRect()
            elementBB.x = elementBB.x - parentBB.x
            elementBB.y = elementBB.y - parentBB.y

            let from = {}
            let to = {}

            let start = {
                x: 0,
                y: 0,
                scale: 1,
                opacity: 1,
            }
            let keys = ['x', 'y', 'scale', 'opacity']
            for (key of keys) {
                if (layer.style && layer.style[key]) {
                    start[key] = layer.style[key]
                    from[key] = layer.style[key]
                    to[key] = layer.style[key]
                }
            }

            // Decide if come from left or right
            let hDirection = 'left'
            if (elementBB.x > parentBB.width / 3) {
                hDirection = 'right'
            }

            let direction = ['horizontal', 'vertical'][Math.floor(Math.random() * 2)]

            if (layer.uniqueId.indexOf('image') != -1 || layer.uniqueId.indexOf('rect') != -1) {
                from.opacity = 0
                to.opacity = start.opacity
                from.scale = 1.1*start.scale
                to.scale = 1*start.scale
            }
            else {
                if (direction == 'vertical') {
                    from.y = -1 * (elementBB.height*0.3) + start.y
                    to.y = 0 + start.y
                } else if (direction == 'horizontal') {
                    if (hDirection == 'left') {
                        from.x = -1 * (elementBB.width*0.6) + start.x
                        to.x = 0 + start.x
                    } else {
                        from.x = elementBB.width*0.6 + start.x
                        to.x = 0 + start.x
                    }
                }
                from.opacity = 0
                to.opacity = start.opacity
            }

            if (reverse) {
                let temp = from
                from = to
                to = temp
            }
            let transitionDuration = TRANSITION_DURATION
            // Disable transition for videos
            if (layer?.element?.type == 'video') {
                transitionDuration = 0
                from = {}
                to = {}
            }
            return {
                layer: layer,
                duration: transitionDuration,
                delay: time,
                element: element,
                from: from,
                to: to,
                kind: reverse? 'out' : 'in',
                groupId: parentId,
            }
        }

        function applyTransform(item, updated) {
            if (typeof updated.value.x != 'undefined' || typeof updated.value.y != 'undefined' || typeof updated.value.scale != 'undefined') {
                let transform = ''
                if (typeof updated.value.x != 'undefined') {
                    transform += 'translateX(' + updated.value.x + 'px) '
                }
                if (typeof updated.value.y != 'undefined') {
                    transform += 'translateY(' + updated.value.y + 'px) '
                }
                if (typeof updated.value.scale != 'undefined') {
                    transform += 'scale(' + updated.value.scale + ') '
                }
                item.element.style.transform = transform
            }
            if (typeof updated.value.opacity != 'undefined') {
                item.element.style.opacity = updated.value.opacity
            }
        }

        function initTimeline(timeline) {
            self.state.timeline = timeline
            for (item of timeline.layers) {
                if (item.kind == 'in') {
                    let updated = tween(easeInOutQuad, 0, item.from, item.to, item.duration, item.delay)
                    applyTransform(item, updated)
                }
            }
        }

        self._playSlow = function() {
            let time = 0
            setInterval(function() {
                self.step(time)
                time += 1000/33
            }, 33)
        }

        self.start = function(type, {statusCb, startDelay}={}) {
            self.stop('initial')
            if (!startDelay) {
                startDelay = 0
            }
            function finishCb(err) {
                self.cleanUp()
                if (err && statusCb) {
                    statusCb(err)
                    return
                }
                if (statusCb) {
                    statusCb(null, 'finished')
                }

                if (type == 'loop') {
                    self.start(type, {statusCb, startDelay})
                }
            }
            self.state.startTimer = setTimeout(function() {
                let iterator = self.animate(self.state.items, type, finishCb)
                self.state.iterator = iterator
            }, startDelay)
        }

        self.step = function(time, cb) {
            if (self.state.iterator) {
                self.state.iterator.next(time, cb)
            }
        }
        self.cleanUp = function() {
            if (!self.state.timeline) {
                return
            }
            // set opacity back to 1 for end transitions
            for (item of self.state.timeline.layers) {
                if (item.type == 'end') {
                    item.element.style.opacity = 1
                }
            }
        }
        self.stop = function(stopType) {
            self.cleanUp()
            if (self.state.startTimer) {
                clearTimeout(self.state.startTimer)
            }
            if (self.state.iterator) {
                self.state.iterator.stop()
            }

            if (stopType != 'initial') {
                window.removeEventListener('message', self.onDocumentMessage)
            }
        }

        self.getDurationTime = function(text) {
            let duration = MIN_PAGE_DURATION
            let speed = self.state.wordPerMinute || WORDS_PER_MINUTE_READING
            try {
                let words = text.stripHtml().split(' ')
                let wordsCount = words.length
                duration = wordsCount / speed * 60 * 1000
                duration = Math.round(duration)
                duration = Math.max(duration, MIN_PAGE_DURATION)
            } catch (e) {
                return MIN_PAGE_DURATION
            }
            return duration
        }

        self.getTimelineDuration = function(cb) {
            self.animate(self.state.items, 'timeline', cb)
        }

        self.getTimelineByElement = function(timeline, kinds) {
            let onShow = {}
            let onEnd = {}

            for (item of timeline.layers) {
                let uniqueId = ''
                if (item.layer && item.layer.uniqueId) {
                    uniqueId = item.groupId + '-' + item.layer.uniqueId
                }
                if (item.kind == 'in') {
                    onShow[uniqueId] = item
                    // Dynamically add video duration
                    if (item?.layer?.element?.type == 'video' && timeline?.durations[uniqueId]) {
                        onEnd[uniqueId] = {
                            delay: item.delay,
                            duration: timeline.durations[uniqueId],
                        }
                        onEnd[uniqueId].kind = 'out'
                    }
                }
                if (item.kind == 'out') {
                    onEnd[uniqueId] = item
                }
            }

            let elements = []
            for (let key in onShow) {
                if (!onShow[key]?.layer?.element) {
                    continue
                }
                if (kinds && kinds.indexOf(onShow[key].layer.element.type) == -1) {
                    continue
                }
                let itemShow = onShow[key]
                let itemEnd = onEnd[key]
                if (!itemEnd || !itemShow) {
                    continue
                }
                let element = {
                    uniqueId: key,
                    groupId: itemShow.groupId,
                    id: itemShow.layer.element.id,
                    show: itemShow.delay,
                    hide: itemEnd.delay + itemEnd.duration,
                }
                if (itemShow.layer.element.type == 'video') {
                    element.src = videoService.getFullSizeVideo(itemShow.layer.element.src)
                }
                elements.push(element)
            }
            return elements
        }

        self.getElementSettings = function(groupId, uniqueId) {
            try {
                if (self.state && self.state.theme && self.state.theme.settings) {
                    let groupSettings = self.state.theme.settings[groupId]
                    if (groupSettings && groupSettings.visual && groupSettings.visual.elements) {
                        return groupSettings.visual.elements[uniqueId] || {}
                    }
                }
            } catch (e) {
            }
            return {}
        }

        self.animate = function(items, loopType, finishCb) {
            let timeline = {
                duration: 0,
                layers: []
            }
            let totalDuration = 0

            function getEndTransition(parentId, delay) {
                let parentElement = document.querySelector('[container-id="' + parentId + '"]')
                let endTransition = {
                    type: 'end',
                    duration: TRANSITION_DURATION,
                    delay: delay || 0,
                    element: parentElement,
                    from: {
                        opacity: 1,
                    },
                    to: {
                        opacity: 0,
                    }
                }
                return endTransition
            }

            // Proportional to size?
            let time = 0
            let coverTime = null
            let notInitialized = false

            let lastGroupTime = 0
            let durations = {}

            for (let parentId = 0; parentId < items.length; parentId++) {
                let group = items[parentId]
                if (!group) {
                    notInitialized = true
                    break
                }
                let groupId = group.id
                let layers = getLayers(group, groupId)
                let fullText = ''
                // In transition
                // TODO - Hardcoded
                let videoElement = null
                let currentTransitions = []
                for (layer of layers) {
                    if (layer && layer.element && layer.element.value && ['h1', 'p', 'span'].indexOf(layer.element.type) != -1) {
                        fullText += layer.element.value.stripHtml().trim() + ' '
                    }
                    if (layer?.element?.type == 'video') {
                        videoElement = {
                            layer: layer,
                            duration: 0,
                        }
                        videoElement.duration = videoService.getCachedVideoDuration(layer.element.src)
                        let settings = self.getElementSettings(parentId, layer.uniqueId)
                        if (settings && settings.duration) {
                            let currentValue =  videoElement.duration
                            videoElement.duration = getValidNumber(settings.duration, currentValue)
                            if (videoElement.duration < 0 || videoElement.duration > currentValue) {
                                videoElement.duration = currentValue
                            }
                        }
                    }
                    // TODO - Update for short videos
                    let transition = getTransition(layer, {parentId, groupId, time})
                    if (!transition) {
                        notInitialized = true
                        break
                    }
                    transition.type = parentId == 0 ? 'initial' : 'chained'
                    timeline.layers.push(transition)
                    currentTransitions.push(transition)
                    totalDuration += transition.duration
                    time += transition.duration
                }
                if (!coverTime) {
                    coverTime = time
                }
                // Calculate page duration
                let pageDuration = self.getDurationTime(fullText)
                if (videoElement && videoElement.duration > 0 && !isNaN(videoElement.duration)) {
                    // Convert to milliseconds
                    let videoDuration = videoElement.duration * 1000
                    let transitionsDuration = (time - lastGroupTime)
                    pageDuration = videoDuration - transitionsDuration

                    // If video is too short, make the page the same duration
                    if (pageDuration < 0) {
                        totalDuration -= transitionsDuration
                        time -= transitionsDuration
                        pageDuration = videoDuration
                        for (let transition of currentTransitions) {
                            transition.duration = 0
                            transition.to = {}
                            transition.from = {}
                        }
                    }
                    let uniqueKey = parentId + '-' + videoElement.layer.uniqueId
                    durations[uniqueKey] = videoDuration
                    // Remove ending transition
                    pageDuration -= TRANSITION_DURATION
                }
                totalDuration += pageDuration
                time += pageDuration

                // Out transition
                for (layer of layers) {
                    // No out transition when there is video
                    if (videoElement && videoElement.duration > 0) {
                        continue
                    }
                    let transition = getTransition(layer, {parentId, groupId, reverse: true, time})
                    if (!transition) {
                        notInitialized = true
                        break
                    }
                    transition.type = 'chained'
                    timeline.layers.push(transition)
                    totalDuration += transition.duration
                    time += transition.duration
                }


                if (parentId < items.length - 1) {
                    let endTransition = getEndTransition(group.id, time)
                    timeline.layers.push(endTransition)
                    if (ADD_ENDING_DURATION_ENABLED) {
                        // TODO - I need this, maybe it is too much
                        //totalDuration += endTransition.duration
                    }
                }
                // Add offset video duration
                lastGroupTime = time
            }
            if (notInitialized) {
                console.error('=> Not initialized')
                return
            }

            if (DEBUG_TIMELINE) {
                console.log('=> Timeline', timeline)
            }

            timeline.duration = totalDuration
            timeline.coverTime = coverTime
            timeline.durations = durations

            $rootScope.$emit('animator.duration', {
                'duration': timeline.duration,
            })

            let currentReq = null
            let startTime = null
            let started = true

            function startAnimating() {
                currentReq = requestAnimationFrame(runTimeline)
                currentReq.onerror = function(e) {
                    console.error('=> Error', e)
                    if (finishCb) {
                        finishCb(e)
                    }
                }
            }

            let activeMap = {}

            function onItemActive(item, uniqueId) {
                //console.log('=> Active', uniqueId)
                if (item.element.tagName == 'VIDEO') {

                    // TODO  TOO MANY TIMES
                    // Reset video time
                    item.element.currentTime = 0
                    item.element.play()
                }
            }
            function onItemInactive(item, uniqueId) {
                //console.log('=> Inactive', uniqueId)
                if (item.element.tagName == 'VIDEO') {
                    //console.log('=> Pausing video', item.element)
                    //item.element.pause()
                }
            }

            function runTimeline(time, loopType) {
                if (!started) {
                    return
                }
                try {
                    if (!startTime) {
                        startTime = time
                    }
                    time = time - startTime
                    let indexLayer = 0
                    for (item of timeline.layers) {
                        let updated = tween(easeInOutQuad, time, item.from, item.to, item.duration, item.delay)
                        let uniqueItemId = ''
                        if (item.layer && item.layer.uniqueId) {
                            uniqueItemId = item.groupId + '-' + item.layer.uniqueId
                        }
                        if (updated.active || updated.last) {
                            if (!activeMap[uniqueItemId] && uniqueItemId) {
                                activeMap[uniqueItemId] = true
                                onItemActive(item, uniqueItemId)
                            }
                            applyTransform(item, updated)
                        }
                        else if (activeMap[uniqueItemId] && !updated.active && uniqueItemId) {
                            activeMap[uniqueItemId] = false
                            onItemInactive(item, uniqueItemId)
                        }
                        indexLayer++
                    }
                    if (loopType != 'manual') {
                        if (time < timeline.duration + 1000) {
                            currentReq = requestAnimationFrame(runTimeline)
                        } else {
                            if (finishCb && started) {
                                finishCb()
                            }
                            cancelAnimationFrame(currentReq)
                        }
                    }
                } catch (e) {
                    if (finishCb && started) {
                        finishCb(e)
                    }
                    console.error('=> Error', e)
                }
            }

            if (loopType == 'timeline') {
                timeline.videos = self.getTimelineByElement(timeline, ['video'])
                finishCb(null, timeline)
                return
            }

            initTimeline(timeline, 'initial')

            if (loopType == 'manual') {
                return {
                    next: function(time, cb) {
                        runTimeline(time, 'manual')
                        if (cb) {
                            cb()
                        }
                    }
                }
            }

            startAnimating()

            return {
                stop: function() {
                    started = false
                    if (currentReq) {
                        cancelAnimationFrame(currentReq)
                    }
                },
            }
        }
        return self;
    }
})